
import { finalize } from 'rxjs/operators';
import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { CPVDTO } from '../../api/plyca-dtos-v2';
import { SearchSettingDTOModal } from '../search/searchGeneric.component';
import { Subject } from 'rxjs';
import { TreeNode } from 'primeng-lts/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../common/baseComponent/base.component';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';

export class SearchSettingCPVDTOModal {
  cpv: CPVDTO;

}

@Component({
  selector: 'searchCPV',
  templateUrl: 'searchCPV.template.html'
})
export class searchCPVComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  context: SearchSettingDTOModal;
  filterText = '';
  private modelChanged: Subject<string> = new Subject<string>();

  MIN_SEARCH_TEXT_LENGHT = 3;

  searchPerformed = false;
  loading = false;

  treeModel: TreeNode[];

  // objeto seleccionado
  selectedObject: CPVDTO;

  constructor(
    private plycaService: PlycaDataService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService
  ) {
    super();
    this.context = dialogConfig['context'];

  }

  ngAfterContentInit(): void {
    //    this.loadData();
    this.waitService.cancelWaiting();
  }

  ngOnDestroy(): void {
    this.modelChanged.unsubscribe();
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  loadData() {

    this.loading = true;
    //////////////////////////////////////////////////
    // OPCION 1. (POR RENDIMIENTO) Carga tirando del fichero que ya tiene la estructura en arbol creada
    //////////////////////////////////////////////////
    // this.plycaService.getCPVsTree().subscribe((datos: any) => {
    //   this.treeModel = datos.content;
    //   this.countItems();
    //   // expandir primer nivel
    //   // this.treeModel.forEach((node: TreeNode) => (node.expanded = true));
    //   this.loading = false;
    // });

    //////////////////////////////////////////////////
    // OPCION 2. Carga tirando del fichero con el listado de cpvs (procesado recursivo para generar la estructura)
    //////////////////////////////////////////////////
    // this.plycaService.getCPVs().subscribe((datos: any) => {
    //   let _roots = this.getCPVRoots(datos.content);

    // 2.1 PROCESAR SECCION A SECCION Y GENERAR FICHERO INDIVIDUAL
    // console.log('RAICES', _roots);
    // _roots.forEach(root => {
    //   let rootCodeNumber = +root.data.code.substring(0, 2);
    //   if (rootCodeNumber == 90) {
    //     let _datos = datos.content.filter(x => {
    //       return +x.code.substring(0, 2) == rootCodeNumber;
    //     });
    //     let treeModel = this.processTree(
    //       _roots,
    //       _datos
    //     );

    //     this.treeModel = treeModel;

    //     this.initializeVisible(this.treeModel);
    //     this.saveText(JSON.stringify(this.treeModel), "cpvsTree" + rootCodeNumber + ".json");
    //   }
    // });

    // 2.2 PROCESAR TODOS LOS REGISTROS Y GENERAR UN FICHERO GLOBAL (FALLA EL STRINGIFY POR EL TAMMANIO: Desarrollao proceso java (PLP.EXP-9174))
    // this.treeModel = this.processTree(
    //   _roots,
    //   datos.content
    // );
    // console.log(JSON.stringify({ content: this.treeModel }));
    // // this.saveText(JSON.stringify({ content: this.treeModel }), "cpvsTree.json");
    // // inicializar visibilidad (false)
    // this.initializeVisible(this.treeModel);
    // // filtramos
    // this.filterInternal(this.treeModel);
    // // eliminamos filtrados
    // this.treeModel = this.removeNoVisible(this.treeModel);
    // this.expandAll();
    // if (this.treeModel.length === 0) {
    //   let nodo: TreeNode = {};
    //   nodo.label = 'No hay cpvs que cumplan la búsqueda';
    //   this.treeModel.push(nodo);
    // }
    //   this.countItems();
    //   this.searchPerformed = true;
    //   this.loading = false;
    // });
  }

  // saveText(text, filename) {
  //   var a = document.createElement('a');
  //   a.setAttribute('href', 'data:text/plain;charset=utf-u,' + encodeURIComponent(text));
  //   a.setAttribute('download', filename);
  //   a.click()
  // }

  processTree(nodes: Array<TreeNode>, datos: Array<CPVDTO>): Array<TreeNode> {
    nodes.forEach(node => {
      let cpv = node.data;
      let childs = this.getChilds(cpv, datos);
      if (childs) {
        this.processTree(childs, datos);
        node.children = childs;
      }
    });
    return nodes;
  }

  getCPVRoots(datos: Array<CPVDTO>): Array<TreeNode> {
    return datos
      .filter(x => {
        return x.code.substring(2, 3) === '0';
        // return x.code == '45000000-7'
      })
      .sort((n1, n2) => {
        if (n1.code > n2.code) {
          return 1;
        }

        if (n1.code < n2.code) {
          return -1;
        }
        return 0;
      })
      .map(x => this.convertUO2Node(x));
  }

  getChilds(parent: CPVDTO, datos: Array<CPVDTO>): Array<TreeNode> {
    let grupo: string = parent.code.substring(0, parent.code.indexOf('0', 2));
    return datos
      .filter(
        x => {
          if (x.code == parent.code) {
            return false;
          }
          let _substr = x.code.substring(grupo.length + 1);
          return (x.code.startsWith(grupo)
            && (_substr.charAt(0) == '0' || _substr.charAt(0) == '-')
          );
        }
      )
      .sort((n1, n2) => {
        if (n1.code > n2.code) {
          return 1;
        }

        if (n1.code < n2.code) {
          return -1;
        }
        return 0;
      })
      .map(x => this.convertUO2Node(x));
  }

  expandAll() {
    this.treeModel.forEach(node => this.expandRecursive(node, true));
  }

  collapseAll() {
    this.treeModel.forEach(node => this.expandRecursive(node, false));
  }

  private expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  convertUO2Node(cpv: CPVDTO): TreeNode {
    let nodo: TreeNode = {};
    nodo.label = cpv.code + ' - ' + cpv.description;
    nodo.data = cpv;
    nodo.children = [];
    return nodo;
  }

  isLoading(): boolean {
    return this.loading;
  }

  cancel(): void {
    this.ref.close();
  }

  accept(selection: any): void {
    if (selection && selection.node) {
      console.log('cpv', selection);
      this.ref.close(selection.node.data);
    }
  }

  changed(text: string) {
    this.modelChanged.next(text);
  }

  updateFilter() {
    this.loading = true;
    this.waitService.startWaiting();
    console.log(this.filterText);
    if (
      this.filterText &&
      this.filterText.length >= this.MIN_SEARCH_TEXT_LENGHT
    ) {
      this.subscribe(this.plycaService.getCPVsTree().pipe(finalize(() => this.waitService.cancelWaiting())), (datos: any) => {
        this.treeModel = datos.content;
        // inicializar visibilidad (false)
        this.initializeVisible(this.treeModel);
        // filtramos
        this.filterInternal(this.treeModel);
        // eliminamos filtrados
        this.treeModel = this.removeNoVisible(this.treeModel);
        // if (this.treeModel.length === 0) {
        //   let nodo: TreeNode = {};
        //   nodo.label = 'No hay cpvs que cumplan la búsqueda';
        //   this.treeModel.push(nodo);
        // }
        this.expandAll();
        this.countItems();
        this.searchPerformed = true;
        this.loading = false;

      });
    } else {
      this.searchPerformed = false;
      this.treeModel = [];
      this.countItems();
      this.loading = false;
      this.waitService.cancelWaiting();
    }
  }

  initializeVisible(nodes: TreeNode[]) {
    nodes.forEach((node: TreeNode) => {
      node['visible'] = false;
      if (node.children) {
        this.initializeVisible(node.children);
      }
    });
  }

  filterInternal(nodes: TreeNode[]) {
    nodes.forEach((node: TreeNode) => {
      let visible = this.compareNode(this.filterText, node);
      // node['visible'] = visible; -> Si se hace la inicializacion esto no es necesario
      if (visible) {
        node.label = this.formatLabel(node.label);
        // if (node.label.indexOf('i>') > 0) {
        //   console.log('label formateada', node.label);
        // }
        this.markNodeTreeAsVisible(node);
      }
      if (node.children) {
        this.filterInternal(node.children);
      }
    });
  }

  formatLabel(nodeLabel: string): string {
    let words = this.normalizeText(this.filterText)
      .trim()
      .split(/\s+/);

    let text = this.normalizeText(nodeLabel);
    words.forEach((word: string) => {
      text = text
        .toLowerCase()
        .replace(word, '<span class="markedtext">' + word + '</span>');
    });
    return text;
  }

  compareNode(searchText: string, node: TreeNode): boolean {
    let words = searchText.trim().split(/\s+/);
    // let words = this.normalizeText(searchText).split(' ');
    let cond1 = this.normalizeText(node.data.code);
    let cond2 = this.normalizeText(node.data.description);
    let ret = false;
    words.forEach((word: string) => {
      if (word !== ' ' && word.length >= this.MIN_SEARCH_TEXT_LENGHT) {
        word = this.normalizeText(word);
        ret = ret || (cond1.indexOf(word) !== -1 || cond2.indexOf(word) !== -1);
      }
    });
    return ret;
  }

  normalizeText(text: string): string {
    return this.quitaAcentos(text).toLowerCase();
  }

  quitaAcentos(s) {
    let r = s.toLowerCase();
    // r = r.replace(new RegExp(/\s/g), '');
    r = r.replace(new RegExp(/[àáâãäå]/g), 'a');
    r = r.replace(new RegExp(/[èéêë]/g), 'e');
    r = r.replace(new RegExp(/[ìíîï]/g), 'i');
    r = r.replace(new RegExp(/ñ/g), 'n');
    r = r.replace(new RegExp(/[òóôõö]/g), 'o');
    r = r.replace(new RegExp(/[ùúûü]/g), 'u');
    return r;
  }

  markNodeTreeAsVisible(node: TreeNode) {
    node['visible'] = true;
    let nodeLevel = node.data.code.substring(2).indexOf('0');
    let level = 0;
    let rootParent = this.treeModel.find((tmp: TreeNode) => {
      return tmp.data.code.startsWith(node.data.code.substring(0, level + 2));
    });
    this.markNodeTreeAsVisibleRecursive(node, rootParent, level++);
  }

  markNodeTreeAsVisibleRecursive(
    node: TreeNode,
    parentNode: TreeNode,
    level: number
  ) {
    if (parentNode) {
      parentNode['visible'] = true;
      if (parentNode.data.code !== node.data.code && parentNode.children) {
        level++;
        let parent2 = parentNode.children.find((tmp: TreeNode) => {
          return tmp.data.code.startsWith(
            node.data.code.substring(0, level + 2)
          );
        });
        if (parent2) {
          this.markNodeTreeAsVisibleRecursive(node, parent2, level++);
        }
      }
    }
  }

  removeNoVisible(nodes: TreeNode[]): TreeNode[] {
    let ret: TreeNode[] = nodes.filter((node: TreeNode) =>
      this.isNodeVisible(node)
    );
    ret
      .filter((node: TreeNode) => node.children)
      .map((node: TreeNode) => {
        if (node.children) {
          node.children = this.removeNoVisible(node.children);
        }
      });
    return ret;
  }

  isNodeVisible(node: TreeNode): boolean {
    let visible = node['visible'];
    if (!visible && node.children) {
      visible = this.isNodeVisibleRecursiva(node.children);
    }
    return visible;
  }

  isNodeVisibleRecursiva(nodes: TreeNode[]) {
    let ret = false;
    if (nodes.find(node => node['visible'])) {
      ret = true;
    } else {
      nodes.forEach((node: TreeNode) => {
        if (node.children) {
          let tmp = this.isNodeVisibleRecursiva(node.children);
          ret = ret || tmp;
        }
      });
    }
    return ret;
  }

  count = 0;
  getItemCount() {
    return this.count;
  }

  countItems() {
    this.count = 0;
    this.countItemsInternal(this.treeModel);
  }
  countItemsInternal(nodes: TreeNode[]) {
    this.count += nodes.length;
    //    this.countItemsInternal (node.children);
    nodes.forEach((node: TreeNode) => {
      if (node.children) {
        this.countItemsInternal(node.children);
      }
    });
  }
}
